import { t } from 'ttag'

export const NON_FIELD_ERRORS = 'non_field_errors'

export const getApiError = (error, type) => {
  if (error?.type === 400) {
    const errors = {
      [NON_FIELD_ERRORS]: t`Name needs to be unique.`,
    }

    return errors[type]
  }

  return null
}
